// extracted by mini-css-extract-plugin
export default {"darkBox":"DarkMode_darkBox__r3dgw"};